import FontAwesomeIcon from '@/lib/iconLibrary'

export default {
  install: app => {
    app.component('FontAwesomeIcon', FontAwesomeIcon)
  },
}
